import api from '@/api/fetch'
import type { Config } from '@/types/config'

export function getConfig() {
  return api.get<Config>('/kds/config').then(res => res.data)
}
